import {
  CalendarToday as CalendarTodayIcon,
  HistoryOutlined as HistoryOutlinedIcon,
  InfoOutlined,
  Schedule as ScheduleIcon,
} from '@mui/icons-material';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { MiniSidebar } from 'src/components/sidebar';
import { PATHS } from 'src/constants/paths';
import { getPaths, lang, useUserRole } from 'src/utils';

import { useLocationTimingPage } from '../timingLocationPage/hooks/TimingLocationPage.hook';
import { Container, Content } from './LocationSubNavbar.styled';

export const LocationSubNavbar = () => {
  const { locationCode = '', scheduleId = '' } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { isOwnerOperator } = useUserRole();
  const paths = getPaths(location.pathname).slice(1);

  const schedulePath = PATHS.LOCATION_SCHEDULE(locationCode);
  const timingsPath = PATHS.LOCATION_TIMINGS(locationCode);
  const detailsPath = PATHS.LOCATION_DETAILS(locationCode);
  const timeMachinePath = PATHS.LOCATION_TIME_MACHINE(locationCode);
  const calendarPath = PATHS.LOCATION_CALENDAR(locationCode);

  const { locationData } = useLocationTimingPage(locationCode);

  const hasAssignedLocationGroup = locationData?.locationGroups?.some(
    (group) => !group.is_default,
  );

  const items = [
    {
      icon: <InfoOutlined />,
      onClick: () =>
        navigate({
          pathname: detailsPath,
          search: location.search,
        }),
      isSelected: paths.includes(detailsPath),
      tooltipMessage: lang.locationDetails,
    },
    {
      icon: <CalendarTodayIcon />,
      onClick: () =>
        navigate({
          pathname: calendarPath,
          search: location.search,
        }),
      isSelected: paths.includes(schedulePath) || paths.includes(calendarPath),
      tooltipMessage: lang.locationSchedule,
      disabled: !hasAssignedLocationGroup,
    },
    {
      icon: <ScheduleIcon />,
      onClick: () =>
        navigate({
          pathname: timingsPath,
          search: location.search,
        }),
      isSelected: paths.includes(timingsPath),
      tooltipMessage: lang.locationTimings,
    },
  ];
  if (!isOwnerOperator) {
    items.push({
      icon: <HistoryOutlinedIcon />,
      tooltipMessage: lang.menuBoardHistory,
      onClick: () =>
        navigate({
          pathname: timeMachinePath,
          search: location.search,
        }),
      isSelected: paths.includes(timeMachinePath),
    });
  }
  const isDetailsPage = paths.includes(detailsPath);
  const showMiniBar = !(
    (isOwnerOperator && isDetailsPage) ||
    paths.includes(PATHS.LOCATION_SCHEDULE_ALL(locationCode, scheduleId)) ||
    paths.some((path) => path.includes('menu-board-modification'))
  );

  return (
    <Container>
      {showMiniBar && <MiniSidebar items={items} />}

      {showMiniBar ? (
        <Content>
          <Outlet />
        </Content>
      ) : (
        <Outlet />
      )}
    </Container>
  );
};
